import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

import { addCommas } from "@persian-tools/persian-tools";

import { FiEdit } from "react-icons/fi";
import { FaMinus, FaPlus, FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import {
  BsFillPlusSquareFill,
  BsFileMinusFill,
  BsCartPlus,
} from "react-icons/bs";
import { AiFillMinusSquareFill } from "react-icons/ai";
import sendRequest from "hooks/useAxios";
// amazing product text
import text from "../../assets/images/63494995.png";
import { useEffect, useState } from "react";
// start of slider
import { NavLink } from "react-router-dom";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";

export default ({ products, cover, isAdmin }) => {
  const [amazingProduct, setAmazingProduct] = useState([]);
  useEffect(() => {
    sendRequest(
      "Find_products",

      {
        tbl_name: `left join,files,coverimg_fileid,id`,
        conditions: `main_discount/!=/0@@main_discount_endtime/>/'${Math.floor(
          new Date() / 1000
        )}'`,
      }
    ).then(({ data }) => {
      setAmazingProduct(data);
    });
  }, []);
  return (
    amazingProduct.length > 0 && (
      <div className="products mb-5 position-relative">
        {/* {isAdmin && (
        <div
          className="position-absolute edit-icon text-light p-1"
          style={{
            backgroundColor: "navy",
            right: "10px",
            zIndex: "10",
            fontSize: "14px",
          }}
        >
          <FiEdit className="mx-1 "></FiEdit>
          ویرایش
        </div>
      )} */}
        {/* start of slider */}
        <Swiper
          dir="rtl"
          spaceBetween={10}
          // centeredSlides={true}
          navigation={true}
          modules={[Navigation]}
          breakpoints={{
            1200: {
              slidesPerView: 4.5,
              spaceBetween: 20,
            },
            800: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            // 700: {
            //   slidesPerView: 3,
            //   spaceBetween: 20,
            // },
            400: {
              slidesPerView: 2.5,
              spaceBetween: 5,
            },
            320: {
              slidesPerView: 2.5,
              spaceBetween: 5,
            },
          }}
        >
          {/*start of first slide that different than others */}
          <SwiperSlide className="my-4 mx-0 text-light">
            <div className="d-flex flex-column align-items-center">
              <img className="my-3 justify amazing-text" src={text}></img>
              <img src={cover} className="my-3 amazing-image"></img>
            </div>
          </SwiperSlide>
          {/*end of first slide that different than others */}
          {amazingProduct.map((value) => {
            return (
              <SwiperSlide
                className="swiper-slides my-4"
                style={{ borderRadius: "12px" }}
              >
                {/* content of slider */}
                <NavLink
                  to={`/product/${value.id}`}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    width: "100%",
                  }}
                >
                  <Slide productDetail={value} isAdmin={isAdmin}></Slide>
                </NavLink>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {/* end of slider */}
      </div>
    )
  );
};
// end of slider

// start of slides content
function Slide({
  productDetail,
  type,
  isAdmin,
  setSelectedEditProduct,
  cartItem,
}) {
  // const a =
  //   100 -
  //   Math.floor((productDetail.main_discount / productDetail.main_price) * 100);
  const a = Math.floor(
    (productDetail.main_discount / productDetail.main_price) * 100
  );

  // countdown variables
  const startTime = new Date().getTime() / 1000;
  const endTime = productDetail.main_discount_endtime;

  const minuteSeconds = 60;
  const hourSeconds = 3600;
  const daySeconds = 86400;

  const timerProps = {
    isPlaying: true,
    strokeWidth: 6,
  };

  const renderTime = (dimension, time) => {
    return (
      <div className="time-wrapper">
        <div className="time">{time}</div>
        <div>{dimension}</div>
      </div>
    );
  };

  const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
  const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;
  const getTimeHours = (time) => ((time % daySeconds) / hourSeconds) | 0;
  const getTimeDays = (time) => (time / daySeconds) | 0;
  // end of countdoown variables

  const priceCondition = () => {
    if (productDetail.main_discount != "0") {
      if (
        (productDetail.main_discount_endtime != "0" && endTime >= startTime) ||
        // !productDetail.main_discount_endtime
        productDetail.main_discount_endtime == "0"
      ) {
        {
          return discountContainer;
        }
      } else if (productDetail.main_discount_endtime && endTime < startTime) {
        return <>{addCommas(productDetail.main_price)} ت</>;
      }
    } else {
      return <>{addCommas(productDetail.main_price)}ت</>;
    }
  };
  const discountContainer = (
    // productDetail.main_discount != "0" ? (
    <div className="d-flex flex-wrap">
      <div className=" col-12  col-lg-6">
        <del>{addCommas(productDetail.main_price)}</del>
      </div>

      <div className=" col-12  col-lg-6">
        <ins style={{ textDecoration: "none", color: "red" }}>
          {productDetail.main_discount
            ? `${addCommas(
                productDetail.main_price - productDetail.main_discount
              )} ت`
            : ""}
        </ins>
      </div>
    </div>
  );
  // ) : (
  //   <div className="d-flex flex-wrap">
  //     <div className="me-3">{addCommas(productDetail.main_price)}تومان</div>
  //   </div>
  // );
  const discountSection = (
    <div className="justify-content-center d-flex">
      <div className="">
        {/* count down */}
        <App></App>
      </div>
      <div className=" mx-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25.1"
          height="23.9"
          viewBox="0 0 25.1 23.9"
        >
          <g
            id="Icon_feather-clock"
            data-name="Icon feather-clock"
            transform="translate(-2.5 -2.5)"
          >
            <path
              id="Path_228"
              data-name="Path 228"
              d="M27.1,14.45c0,6.324-5.395,11.45-12.05,11.45S3,20.774,3,14.45,8.395,3,15.05,3,27.1,8.126,27.1,14.45Z"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
            <path
              id="Path_229"
              data-name="Path 229"
              d="M18,9V21.075L24,25.1"
              transform="translate(-3.688 -4.2)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
          </g>
        </svg>
      </div>
    </div>
  );
  const percentCondition = () => {
    if (
      (productDetail.main_discount_endtime && endTime >= startTime) ||
      !productDetail.main_discount_endtime
    ) {
      {
        return percent;
      }
    }
  };
  const percent = (
    <div
      style={{ height: "20px", top: "10px", right: "10px" }}
      className="position-absolute "
    >
      <div
        className="rounded-pill bg-danger text-center percent text-light"
        // style={{ width: "60px" }}
      >
        {a > 0 ? `% ${a}` : " "}
      </div>
    </div>
  );

  // start of count down component
  function App() {
    const remainingTime = endTime - startTime;
    const days = Math.ceil(remainingTime / daySeconds);
    const daysDuration = days * daySeconds;

    return (
      <div
        className="App d-flex align-items-center w-100"
        style={{ width: "10px", color: "darkgray" }}
      >
        <CountdownCircleTimer
          {...timerProps}
          colors="darkgray"
          size="20px"
          duration={minuteSeconds}
          initialRemainingTime={remainingTime % minuteSeconds}
          onComplete={(totalElapsedTime) => ({
            shouldRepeat: remainingTime - totalElapsedTime > 0,
          })}
        >
          {({ elapsedTime, color }) => (
            <span style={{ color }}>
              {renderTime(getTimeSeconds(elapsedTime))}
            </span>
          )}
        </CountdownCircleTimer>
        :
        <CountdownCircleTimer
          {...timerProps}
          colors="darkgray"
          size="20px"
          duration={hourSeconds}
          initialRemainingTime={remainingTime % hourSeconds}
          onComplete={(totalElapsedTime) => ({
            shouldRepeat: remainingTime - totalElapsedTime > minuteSeconds,
          })}
        >
          {({ elapsedTime, color }) => (
            <span style={{ color }}>
              {renderTime(getTimeMinutes(hourSeconds - elapsedTime))}
            </span>
          )}
        </CountdownCircleTimer>
        :
        <CountdownCircleTimer
          {...timerProps}
          colors="darkgray"
          size="20px"
          duration={daySeconds}
          initialRemainingTime={remainingTime % daySeconds}
          onComplete={(totalElapsedTime) => ({
            shouldRepeat: remainingTime - totalElapsedTime > hourSeconds,
          })}
        >
          {({ elapsedTime, color }) => (
            <span style={{ color }}>
              {renderTime(getTimeHours(daySeconds - elapsedTime))}
            </span>
          )}
        </CountdownCircleTimer>
        :
        <CountdownCircleTimer
          {...timerProps}
          size="20px"
          colors="darkgray"
          duration={daysDuration}
          initialRemainingTime={remainingTime}
        >
          {({ elapsedTime, color }) => (
            <span style={{ color }}>
              {renderTime(getTimeDays(daysDuration - elapsedTime))}
            </span>
          )}
        </CountdownCircleTimer>
      </div>
    );
  }
  // end of count down component
  const auth = useContext(WithAuthentication);
  return (
    <div
      className="slide-item card shadow amazing-product w-100"
      style={{ borderRadius: "12px" }}
    >
      <div>{percentCondition()}</div>
      <div className="product-img card-img-top position-relative text-center">
        <img
          src={`http://oilb.tatdemo.ir/${productDetail.url}`}
          // className="w-100"
          // className="product-img card-img-top position-relative"
          style={{ borderRadius: "12px" }}
        ></img>
        {isAdmin && (
          <div
            className="position-absolute edit-style w-100  py-1 text-center"
            style={{ bottom: "0" }}
            data-bs-toggle="modal"
            data-bs-target="#editProductModalUnique"
            onClick={() => {
              setSelectedEditProduct(productDetail);
              console.log(productDetail);
            }}
          >
            ویرایش <FaRegEdit />
          </div>
        )}
      </div>

      <div className="card-body d-flex flex-column  ">
        {/* title */}
        <div className="two-line product-title " id="#one-line">
          {productDetail.title}
        </div>
        {/* rate */}
        {/* <div className="my-2 product-rate" style={{ textAlign: "left" }}>
          ({productDetail.rating_count}){productDetail.avg_rating}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="19"
            viewBox="0 0 15 19"
          >
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M8.137.66,6.306,5.573l-4.1.79c-.735.141-1.029,1.339-.5,2.026l2.964,3.822-.7,5.4c-.126.976.65,1.707,1.3,1.25l3.664-2.549,3.664,2.549c.65.453,1.427-.275,1.3-1.25l-.7-5.4,2.964-3.822c.533-.686.238-1.885-.5-2.026l-4.1-.79L9.746.66a.82.82,0,0,0-1.609,0Z"
              transform="translate(-1.441 0.001)"
              fill="#eca72c"
            />
          </svg>
        </div> */}
        {/* price */}
        <div className="mb-2 mt-1 product-price fw-bold">
          {priceCondition()}
        </div>
        {/* counter */}
        <div className="product-discount">
          {endTime > startTime ? discountSection : null}
        </div>
        {type == "hashtags" && (
          <div
            className=" d-flex justify-content-center align-items-center"
            style={{ height: 30 }}
          >
            {productDetail.cartItem_count != 0 ? (
              <>
                <div className="bg-danger rounded">
                  <FaPlus
                    className="m-1"
                    onClick={() => {
                      cartItem("increase", productDetail.id);
                    }}
                    style={{
                      width: 15,
                      height: 15,
                      color: "white",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <span className="mx-2">{productDetail.cartItem_count}</span>

                {productDetail.cartItem_count == "1" && (
                  <div className="bg-danger rounded ">
                    <FaRegTrashAlt
                      className="m-1"
                      onClick={() => {
                        cartItem("decrease", productDetail.id);
                      }}
                      style={{
                        width: 15,
                        height: 15,
                        color: "white",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                )}
                {productDetail.cartItem_count != "1" && (
                  <div
                    className={` rounded ${
                      productDetail.cartItem_count == "0"
                        ? "bg-secondary"
                        : "bg-danger"
                    }`}
                  >
                    <FaMinus
                      className="m-1"
                      onClick={() => {
                        cartItem("decrease", productDetail.id);
                      }}
                      style={{
                        width: 15,
                        height: 15,
                        color: "white",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <div
                  className="bg-danger rounded"
                  onClick={() => {
                    cartItem("increase", productDetail.id);
                  }}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="modal"
                  data-bs-target={`${!auth.isLogged && "#ModalNumber"}`}
                >
                  <BsCartPlus
                    className="m-1"
                    style={{
                      width: 20,
                      height: 20,
                      color: "white",
                    }}
                  />{" "}
                  <span className="ms-1 me-2 text-light">خرید</span>
                </div>{" "}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
// end of slides content
export { Slide };
